import { Spinner } from "@repo/ui";

export const LoadingState = () => (
  <div className="mb-4 flex h-32 items-center justify-center gap-2">
    <Spinner />
    <span className="text-sm text-gray-500">Loading lists...</span>
  </div>
);

export const NoListsState = () => (
  <div className="mb-4 flex h-32 items-center justify-center">
    <span className="text-sm text-gray-500">No lists available</span>
  </div>
);
